import axios from 'axios'
import moment from 'moment'
import * as _ from 'lodash-joins'
import CS from '../../commons/services/Common'
import MS from '../../commons/services/Moment'
import MakeKey from '../../commons/services/MakeKey'

import { Notification, Message, MessageBox } from "element-react";

const OPTIONS = {
    method: 'POST',
    mode: 'cors',
    headers: {
        'Content-Type': 'application/json',
        'apikey-plant-1': 'Y!Ptm6yXhecvu5jA=ZsSMW-MQeWNWq3L3qxgMe4qSCU4DT6mtGLX?rSdDkCV7m@D$74?K%gz&NJHgZg@d&X5--XYBcxyX3c?JrZP9w2mQEF_wNTMArnvzttyN*3w%A5L',
    },
};

const DELETE_OPTIONS = {
    method: 'DELETE',
    mode: 'cors',
    headers: {
        'Content-Type': 'application/json',
        'apikey-plant-1': 'Y!Ptm6yXhecvu5jA=ZsSMW-MQeWNWq3L3qxgMe4qSCU4DT6mtGLX?rSdDkCV7m@D$74?K%gz&NJHgZg@d&X5--XYBcxyX3c?JrZP9w2mQEF_wNTMArnvzttyN*3w%A5L',
    },
};

const API_DOMAIN = process.env.REACT_APP_MONITORINGAPI_URL;


class MonitoringApiService {

    // doFetchApi = async (url, options) => {
    //     const response = await fetch(url, options);
    //     const responseOK = response && response.ok;
    //     if (responseOK) {
    //         const data = await response.json();
    //         return data;
    //     }
    // }

    doFetchApi = async (url, options) => {
        const response = await fetch(url, options);
        const responseOK = response && response.ok;
        
        if (responseOK) {
            const text = await response.text(); // 응답을 먼저 텍스트로 확인
            try {
                const data = JSON.parse(text); // JSON으로 변환 가능하면 변환
                return data;
            } catch (error) {
                console.error("JSON 파싱 오류, return value 빈값일 가능성 있음:", error, text); // JSON이 아닐 때 에러 로그
                return text; // JSON 파싱이 실패하면 텍스트 그대로 반환
            }
        } else {
            console.error("Fetch 실패:", response.status, response.statusText);
        }
    };
    

    getTest = async() => {
        const url = `${API_DOMAIN}/monitoring-module/test`;
        const res = await this.doFetchApi(url, OPTIONS);
        //console.log(res)
    }

    getInverterList = async(param) => {
        const url = `${API_DOMAIN}/monitoring-inverter/list`;
        OPTIONS.body = JSON.stringify(param);;
        return await this.doFetchApi(url, OPTIONS);
    }

    getStatInverterList = async(param) => {
        const url = `${API_DOMAIN}/monitoring-inverter/stat/list`;
        OPTIONS.body = JSON.stringify(param);;
        return await this.doFetchApi(url, OPTIONS);
    }

    createStatInverter = async(param) => {
        const url = `${API_DOMAIN}/monitoring-inverter/stat/create`;
        OPTIONS.body = JSON.stringify(param);;
        return await this.doFetchApi(url, OPTIONS);
    }

    updateStatInverter = async(param) => {
        const url = `${API_DOMAIN}/monitoring-inverter/stat/update`;
        OPTIONS.body = JSON.stringify(param);;
        return await this.doFetchApi(url, OPTIONS);
    }

    deleteStatInverter = async(param) => {
        const url = `${API_DOMAIN}/monitoring-inverter/stat/delete`;
        DELETE_OPTIONS.body = JSON.stringify(param);;
        const response = await fetch(url, DELETE_OPTIONS);
    }

    getTodayPower = async (param) => {
        const url = `${API_DOMAIN}/monitoring-inverter/stat`;
        OPTIONS.body = JSON.stringify(param);
        const data = await this.doFetchApi(url, OPTIONS);
        return (data.length === 0) ? 0 : data[0].power
    }

    getPowerList = async (param) => {
        const url = `${API_DOMAIN}/monitoring-inverter/stat`;
        OPTIONS.body = JSON.stringify(param);
        return await this.doFetchApi(url, OPTIONS);
    }

    getAccumulationPowerList = async (param) => {
        const url = `${API_DOMAIN}/monitoring-inverter/accumulation-power`;
        OPTIONS.body = JSON.stringify(param);
        return await this.doFetchApi(url, OPTIONS);
    }

    getLatestInverter = async(param, colName) => {
        const url = `${API_DOMAIN}/monitoring-inverter/latest`;
        OPTIONS.body = JSON.stringify(param);
        return await this.doFetchApi(url, OPTIONS);
    }

    getInverterOfLastHour = async(param) => {
        const url = `${API_DOMAIN}/monitoring-inverter/last-hour`;
        OPTIONS.body = JSON.stringify(param);
        return await this.doFetchApi(url, OPTIONS);
    }

    getAllDeviceData = async(siteNo) => {
        const url = `${API_DOMAIN}/monitoring-device/device/all`;
        OPTIONS.body = JSON.stringify({ siteNo }); 
        return await this.doFetchApi(url, OPTIONS);
    }

    getDevicesData = async(deviceNos) => {
        const url = `${API_DOMAIN}/monitoring-device/device`;
        const body = JSON.stringify({ deviceNos });
        const options = { ...OPTIONS, body };
        return await this.doFetchApi(url, options);
    }

    getCarrierPowerList = async (param) => {
        const url = `${API_DOMAIN}/monitoring-device/stat/carrier`;
        OPTIONS.body = JSON.stringify(param);
        return await this.doFetchApi(url, OPTIONS);
    }

    // 20241129 carrier data 추가
    /**
     * 
     * @param {*} siteNo 
     * @param {*} deviceNos 
     * @returns 
     */
    getCarriersData = async({ siteNo, deviceNos, rtuId }) => {
        const url = `${API_DOMAIN}/monitoring-device/carrier`;
        const body = JSON.stringify({ siteNo, deviceNos, rtuId });
        const options = { ...OPTIONS, body };
        return await this.doFetchApi(url, options);
    }

    // 20250226 carrier data 수정본
    getCarriersData  = async(carrierSerialNos) => {
        const url = `${API_DOMAIN}/monitoring-device/carrier`;
        const body = JSON.stringify({ carrierSerialNos });
        const options = { ...OPTIONS, body };
        return await this.doFetchApi(url, options);
    }

    // 20241129 carrier 기기제어 추가
    /**
     * 
     * @param {*} rtuId 
     * @param {*} siteNo 
     * @param {*} deviceId 
     * @param {*} kind 보일러: 60
     * @param {*} controlKind 0: 실내온도, 1: 축열조온도, 2: 실내기입력정보, 3: UC운전모드, 4: UC부가운전1, 5: 예약, 6: 축열조설정온도, 7: 예약, 8: 실내설정온도, 9: 히터설정온도
     * @param {*} val 설정값
     * @returns 
     */
    sendMessageToDevice = async(rtuId, siteNo, deviceId, kind, controlKind, val) => {
        const url = `${API_DOMAIN}/monitoring-device/sendMessage`;
        const body = JSON.stringify({ rtuId, siteNo, deviceId, kind, controlKind, val });
        const options = { ...OPTIONS, body };
        return await this.doFetchApi(url, options);
    }

    /**
     * 
     * @param {*} rtuId
     * @param {*} siteNo
     * @param {*} deviceId
     * @param {*} kind // 23
     * @param {*} controlKind // on: 2(난방), off: 0
     * @param {*} serialNos 
     * @returns 
     */
    sendMessageToModule = async({
        rtuId,
        siteNo,
        deviceId,
        kind,
        controlKind,
        serialNos,
    }) => {
        const url = `${API_DOMAIN}/monitoring-module/sendMessage`;
        const body = JSON.stringify({ rtuId, siteNo, deviceId, kind, controlKind, serialNos });
        const options = { ...OPTIONS, body };
        return await this.doFetchApi(url, options);
    }


    // 20241213 battery 상세정보 추가
    /**
     * 
     * @param {*} siteNo
     * @param {*} deviceNos
     * @param {*} rtuId
     */
    getBatteryDetail = async({ siteNo, deviceNos, rtuId }) => {
        const uniqueDeviceNos = _.uniq(deviceNos);
        const batterySerialNos = uniqueDeviceNos.map(deviceNo => MakeKey.battery({ siteNo, rtuNo: rtuId, kind: 60, deviceNo }));

        const url = `${API_DOMAIN}/monitoring-device/battery`;
        const body = JSON.stringify({ siteNo, deviceNos, rtuId });
        const options = { ...OPTIONS, body };
        return await this.doFetchApi(url, options);
    }
    // 20250226 battery 상세정보 수정본
    getBatteryDetail = async(batterySerialNos) => {
        const url = `${API_DOMAIN}/monitoring-device/battery`;
        const body = JSON.stringify({ batterySerialNos });
        const options = { ...OPTIONS, body };
        return await this.doFetchApi(url, options);
    }

    getDrNos = async () => {
        const url = `${API_DOMAIN}/api/dr/dr_res_ids`;
        const options = { ...OPTIONS };
        return await this.doFetchApi(url, options);
    }
    
    getLatestModuleList = async(param, plantId) => {
        const url = `${API_DOMAIN}/monitoring-module/latest`;
        OPTIONS.body = JSON.stringify(param);
        const result = await this.doFetchApi(url, OPTIONS)

        /*임시(발전소 아이디)
        if (plantId == 20) {
            //console.log(result)
            const copy1 = CS.cloneObj(result[0]);
            copy1._id = "acea777a-3cea-408f-bbbc-c16d33bb6101"
            result.push(copy1);

            const copy2 = CS.cloneObj(result[3]);
            copy2._id = "acea777a-3cea-408f-bbbc-c16d33bb6106"
            result.push(copy2);

            const copy3 = CS.cloneObj(result[4]);
            copy3._id = "acea777a-3cea-408f-bbbc-c16d33bb6107"
            result.push(copy3);

            const copy4 = CS.cloneObj(result[7]);
            copy4._id = "acea777a-3cea-408f-bbbc-c16d33bb6111"
            result.push(copy4);
        }
        */
        return result;
    }

    getTestTool = async(param) => {
        const url = `${API_DOMAIN}/test-rnd/parsePacket`;
        OPTIONS.body = JSON.stringify(param);

        const response = await fetch(url, OPTIONS);
        const responseOK = response && response.ok;
        const text = await response.text();
        if (responseOK) {
            // const text = response; // 응답을 먼저 텍스트로 확인
            try {
                return JSON.parse(text);
            } catch (error) {
                console.error("JSON 파싱 오류, return value 빈값일 가능성 있음:", error, text); // JSON이 아닐 때 에러 로그
                return text; // JSON 파싱이 실패하면 텍스트 그대로 반환
            }
        } else {
            // 실패한 경우에도 본문을 던진다
            let errorData;
            try {
                errorData = JSON.parse(text);
            } catch (e) {
                errorData = { errorMessage: text };
            }
            console.error("Fetch 실패:", response.status, response.statusText, errorData);
            throw errorData; // 주의: Error 인스턴스가 아니라 JSON 데이터 던짐
        }
    }

    // ----------------S: 전력량계 API ---------------- //
    getMeterList = async(param) => {
        const { serialNos } = param;
        const url = `${API_DOMAIN}/monitoring-device/meter`;
        OPTIONS.body = JSON.stringify({ serialNos });
        return await this.doFetchApi(url, OPTIONS);
    }
    // ----------------E: 전력량계 API ---------------- //

    // ----------------S: EMS API ---------------- //
    // EMS 태양광 발전량
    getEmsInvSum = async (param) => {
        const { inverterSerialNos, date } = param;
        const url = `${API_DOMAIN}/monitoring-device/stat/ems/inv/sum`;
        OPTIONS.body = JSON.stringify({ inverterSerialNos, date });
        return await this.doFetchApi(url, OPTIONS);
    }
    // EMS 태양광 당일 시간당 발전량 데이터
    getEmsInvData = async (param) => {
        const { inverterSerialNos, date } = param;
        const url = `${API_DOMAIN}/monitoring-device/stat/ems/inv/data`;
        OPTIONS.body = JSON.stringify({ inverterSerialNos, date });
        return await this.doFetchApi(url, OPTIONS);
    }
    // EMS 전력기기 전력소모량
    getEmsCarrierSum = async (param) => {
        const { carrierSerialNos, date } = param;
        const url = `${API_DOMAIN}/monitoring-device/stat/ems/carrier/sum`;
        OPTIONS.body = JSON.stringify({ carrierSerialNos, date });
        return await this.doFetchApi(url, OPTIONS);
    }
    // EMS 전력기기 당일 시간당 전력소모량 데이터
    getEmsCarrierData = async (param) => {
        const { carrierSerialNos, date } = param;
        const url = `${API_DOMAIN}/monitoring-device/stat/ems/carrier/data`;
        OPTIONS.body = JSON.stringify({ carrierSerialNos, date });
        return await this.doFetchApi(url, OPTIONS);
    }
    // EMS 배터리 충/방전량
    getEmsBatterySum = async (param) => {
        const { batterySerialNos, date } = param;
        const url = `${API_DOMAIN}/monitoring-device/stat/ems/battery/sum`;
        OPTIONS.body = JSON.stringify({ batterySerialNos, date });
        return await this.doFetchApi(url, OPTIONS);
    }
    // EMS 배터리 당일 시간당 충/방전량 데이터
    getEmsBatteryData = async (param) => {
        const { batterySerialNos, date } = param;
        const url = `${API_DOMAIN}/monitoring-device/stat/ems/battery/data`;
        OPTIONS.body = JSON.stringify({ batterySerialNos, date });
        return await this.doFetchApi(url, OPTIONS);
    }

    // ----------------E: EMS API ---------------- //


    getCarrierChart = async (param) => {
        const { carrierSerialNos, date, dateType} = param;
        const url = `${API_DOMAIN}/monitoring-device/carrier/chart/data`;
        OPTIONS.body = JSON.stringify({ carrierSerialNos, date, dateType });
        return await this.doFetchApi(url, OPTIONS);
    }

    getBatteryPeriod = async (param) => {
        const { batterySerialNos, fromDate, toDate } = param;
        const url = `${API_DOMAIN}/monitoring-device/battery/data/period`;
        OPTIONS.body = JSON.stringify({ batterySerialNos, fromDate, toDate });
        return await this.doFetchApi(url, OPTIONS);
    }

    getPowerByInverter(list, colName) {
        let power = 0;
        list.some(v => {
            power += v[colName];
        });
        return power;
    }

    getHourlyAxisx(ymd) {
        const hours = [];
        let hourSize = 24;
        if (ymd == MS.format(new Date(), 'YYYY-MM-DD')) {
            hourSize = parseInt(moment().add(0, 'hours').format("HH"));
        } else {
            hourSize = 24;
        }
        for(let i=0; i < hourSize; i++) {
            hours.push(`${CS.fillZero(2, i.toString())}`)
        }
        return hours;
    }

    getDailyAxisx(ym) {
        const daysThisMonth = [];
        let startOfMonth = moment(ym).startOf('month').format('YYYY-MM-DD');
        let endOfMonth;
        /*
        if (moment().format("YYYY-MM") === ym) {
            endOfMonth = moment().format('YYYY-MM-DD');
        } else {
            endOfMonth = moment(ym).endOf('month').format('YYYY-MM-DD');
        }
        */
        endOfMonth = moment(ym).endOf('month').format('YYYY-MM-DD');
        while (moment(startOfMonth).isBefore(moment(endOfMonth))) {
            daysThisMonth.push(startOfMonth)
            startOfMonth = moment(startOfMonth).add(1, 'days').format('YYYY-MM-DD');
        }
        daysThisMonth.push(endOfMonth);
        return daysThisMonth;
    }

    getMonthlyAxisx(y) {
        const months = [];
        let monthSize = 12;
        /*
        if (moment().format("YYYY") === y) {
            monthSize = parseInt(moment().format("MM"));
        }
        */
        for (let i=1; i <= monthSize; i++) {
            months.push(`${y}-${CS.fillZero(2, i.toString())}`);
        }
        return months;
    }


    settingChartData(arrays, list) {
        //const joinResult = _.sortedMergeFullOuterJoin(arrays, list, "_id");
        const powers = [];
        arrays.some(arr => {
            let power = 0;
            list.some(w => {
                if (w._id === arr) {
                    power = w.power;
                    return true;
                }
            });
            powers.push(power);
        });
        return powers;
    }

    formatNumber(number) {
        let fixedNo = 0;
        if (Number.isInteger(number)) {
            fixedNo = 0;
        } else if (Number.isInteger(number*10)) {
            fixedNo = 1;
        } else  {
            fixedNo = 2;
        }
        return CS.setComma((number).toFixed(fixedNo));
    }



}

export default new MonitoringApiService()
